import { z } from 'zod';
import { BPS_DENOMINATOR, MICRO_USD_MAX_DIGITS } from '../constants';

/**
 * Micro-USD digits, no sign, for a field that stays a string.
 */
export const MicroUsdDigits = z
  .string()
  .regex(
    new RegExp(`^\\d{1,${MICRO_USD_MAX_DIGITS}}$`),
    `expected a whole number of micro-USD, at most ${MICRO_USD_MAX_DIGITS} digits`,
  );
export type MicroUsdDigits = z.infer<typeof MicroUsdDigits>;

/**
 * Micro-USD parsed to bigint; zero is allowed.
 */
export const MicroUsd = MicroUsdDigits.transform((value) => BigInt(value));
export type MicroUsd = z.infer<typeof MicroUsd>;

/**
 * For a price, a deposit, a withdrawal, an offer.
 */
export const PositiveMicroUsd = MicroUsd.refine((value) => value > 0n, {
  message: 'amount must be positive',
});
export type PositiveMicroUsd = z.infer<typeof PositiveMicroUsd>;

/**
 * A rate in whole basis points, 0 to 10000 (0% to 100%).
 */
export const Bps = z.number().int().min(0).max(Number(BPS_DENOMINATOR));
export type Bps = z.infer<typeof Bps>;
